import axios from 'axios';

// 1. O Pulo do Gato: Descobrir onde o frontend está rodando
// Se houver uma variável de ambiente, usamos ela (removendo /api/v1 se presente para evitar duplicidade)
const envUrl = process.env.REACT_APP_API_URL;
const cleanedEnvUrl = envUrl ? envUrl.replace('/api/v1', '').replace(/\/$/, '') : null;

// 2. Definir a URL da API
// Se estivermos em localhost e NÃO houver envUrl, usamos localhost:8080 como fallback para dev local.
// Caso contrário, usamos a URL oficial do Render.
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_BASE_URL = cleanedEnvUrl || (isLocalhost
    ? 'https://gestjus-api.onrender.com'
    : 'https://gestjus-api.onrender.com');

// Log para debug (ajuda a identificar problemas de conexão rapidamente)
console.log(`[API] Base URL configurada: ${API_BASE_URL}`);

// 3. Criamos o Axios já com a bússola configurada e a tolerância ao "Cold Start" do Render
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 180000 // ⏳ 180.000 ms (3 minutos) de paciência para o servidor acordar da hibernação
});

// Interceptador de Requisição (Adiciona o Token JWT)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('gestjus_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Interceptador de Resposta (Trata Sessão Expirada / Erro 401)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Se o erro for de timeout, podemos colocar um log amigável para debug
        if (error.code === 'ECONNABORTED') {
            console.warn("⚠️ O servidor demorou muito para responder. Pode estar acordando da hibernação (Cold Start).");
        }

        if (error.response && error.response.status === 401) {
            // Evitamos redirecionar se o erro 401 ocorrer na própria tentativa de login (/api/v1/auth/login),
            // pois isso gerará recarregamentos de tela infinitos que apagam os logs do console
            // e impedem o usuário de ver a mensagem de credenciais incorretas.
            const isLoginRequest = error.config?.url?.includes('/api/v1/auth/login');
            if (!isLoginRequest) {
                console.warn("Sessão expirada. Redirecionando para o Login...");
                localStorage.removeItem('gestjus_token');
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

export default api;